/**
 * Retourne les erreurs des champs.
 * @param {object} param0
 * @param {object} param0.error
 * @return {Array}
 */
export default function apiGetErrorFields({ error }) {
  return error?.body?.errors?.[0]?.meta?.fields ?? {};
}
